import { render, staticRenderFns } from "./HeatTransferCoefficient.vue?vue&type=template&id=b8815d00&"
import script from "./HeatTransferCoefficient.vue?vue&type=script&lang=js&"
export * from "./HeatTransferCoefficient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports